const $ = (el) => document.querySelector(el);
const $$ = (el) => document.querySelectorAll(el);

class Leaving {
  constructor() {
    let hasExternalLinks = $('.leaving-this-site');

    if (hasExternalLinks) {
      $$('.external').forEach((externalLink) => {
        externalLink.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();

          $('.leaving-this-site').classList.add('active');

          // get the external URL
          let externalUrl = '';

          if (event.target.localName == 'span') {
            externalUrl = event.currentTarget.closest('a').getAttribute('href');
          } else {
            externalUrl = event.currentTarget.getAttribute('href');
          }

          console.log(externalUrl);

          $('.leaving-this-site').setAttribute('data-url', externalUrl);


        });
      });

      $$('.shadow, .cancel').forEach((btn) => {
        btn.addEventListener('click', () => {
          $('.leaving-this-site').classList.remove('active');
        });
      });

      $('.ok').addEventListener('click', () => {
        let url = $('.leaving-this-site').getAttribute('data-url');
        $('.leaving-this-site').classList.remove('active');
        window.open(url);
      });
    }
  }

}

export default Leaving;